import "../../node_modules/@fortawesome/fontawesome-free/css/brands.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/fontawesome.css";
import "../../node_modules/@fortawesome/fontawesome-free/css/solid.css";
import { Game } from "./scripts/game";
import "./scss/pages/client.scss";
import "./scss/momo-menu.scss";
import "./scss/momo-wardrobe.scss";
import "./scss/momo-hud.scss";
import { initMomoMenu } from "./scripts/momoMenu";

initMomoMenu();
void Game.init();
